<script setup lang="ts">
  import { inject } from 'vue'
  import _fetch from '@/utils/fetch'
  import type { MessageServiceType } from '@components/components/AppMessage/message'
  import type { LoginServiceType } from '@common/components/AppLogin/login'

  const props = defineProps<{
    following: boolean
    id: string | number
    followText?: string
    disabled?: boolean
  }>()
  const emit = defineEmits(['follow'])
  const $message = inject<MessageServiceType>('$message')
  const $login = inject<LoginServiceType>('$login')
  const followText = props.followText || '关注'

  let isLoggedIn = window.isLoggedIn
  const ifLoginFollow = () => {
    isLoggedIn = window.isLoggedIn
    if (!isLoggedIn) {
      $login &&
        $login({
          type: 'login',
          onSuccess() {
            isLoggedIn = true
            beginFollow()
          }
        })
      return
    }
    beginFollow()
  }
  const beginFollow = () => {
    if (props.disabled) return
    // 取消关注
    if (props.following) {
      $message &&
        $message({
          message: '确定要取关此用户吗？',
          timer: 0,
          config: {
            showClose: false,
            showIcon: false,
            showCancel: true,
            showConfirm: true,
            confirmText: '确定',
            cancelText: '取消'
          },
          onConfirm: async () => {
            followUser()
          }
        })
      return false
    }
    followUser()
  }
  // 关注|取关
  const followUser = async () => {
    // 关注
    let response
    if (!props.following) {
      response = await _fetch('/aigc/api/follow/add', {
        method: 'POST',
        body: JSON.stringify({
          followedUserId: props.id
        })
      })
    } else {
      // 取消关注
      response = await _fetch('/aigc/api/follow/cancel', {
        method: 'POST',
        body: JSON.stringify({
          followedUserId: props.id
        })
      })
    }
    if (!response) return
    const res = await response.json()
    if (res.code === 200) {
      const newFollowing = !props.following
      emit('follow', newFollowing)
      // item.following = !item.following;
    } else {
      $message &&
        $message({
          title: 'Failed',
          message: `${res.msg}`,
          type: 'error'
        })
    }
  }
</script>
<template>
  <div
    @click="ifLoginFollow"
    :class="[`${props.following ? 'button' : 'button-primary'}`, 'follow-item-btn']"
  >
    {{ props.following ? '关注中' : followText }}
  </div>
</template>
<style lang="stylus" scoped>
  .follow-item-btn
      cursor pointer
      padding 0 2.4rem
      height 4.8rem
      font-size 1.6rem
</style>
